<template>
  <md-dialog :md-active.sync="dialog" width="400" @md-closed="cancel">
    <md-card xs12 sm6 style="text-align:center">
      <md-card-header>
        <div class="md-title">{{dialogTitle}}</div>
      </md-card-header>
      <md-card-content>
        <md-datepicker style="margin:0 auto" v-model="date" :md-disabled-dates="allowedDates">
          <label>{{ label }}</label>
        </md-datepicker>
      </md-card-content>

      <md-card-actions>
        <md-divider />
        <md-button @click="cancel" class="md-primary play-cta-button-flat grey">Cancel</md-button>
        <md-button @click="clear" class="md-primary play-cta-button-flat grey">Clear</md-button>
        <md-button @click="dateSelected" class="md-primary play-cta-button makeup">OK</md-button>
      </md-card-actions>
    </md-card>
  </md-dialog>
</template>

<script>
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    dialogTitle: {
      type: String,
      required: true
    },
    allowedDates: {
      type: Function,
      required: false
    },
    label: {
        type: String,
        default: '',
    }
  },
  data: () => ({
    date: undefined,
    dialog: false
  }),
  created() {
    this.dialog = this.showDialog;
  },
  watch: {
    showDialog: function(val) {
      this.dialog = val;
    }
  },
  methods: {
    clear() {
      this.$emit("emitClear");
      this.dialog = false;
    },
    dateSelected() {
      if (this.date) {
        var d = new Date(this.date);
        this.$emit("emitSelectedDate", d);
      }
      this.dialog = false;
    },
    cancel() {
      this.$emit("emitCancel");
      this.dialog = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dialogs/dialogDatePicker.vue